import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export default function PoliticaPrivacidade() {
  return (
    <div className="min-h-screen bg-muted/30 px-4 py-10">
      <div className="mx-auto max-w-3xl space-y-6">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">WeAuto</p>
          <h1 className="text-3xl font-bold">Política de Privacidade</h1>
          <p className="text-sm text-muted-foreground">
            Última atualização: 2 de maio de 2026.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Dados tratados</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              Tratamos dados cadastrais da loja e dos usuários, além de dados operacionais inseridos na
              plataforma, como avaliações, veículos, documentos e fechamentos.
            </p>
            <p>
              Também podemos tratar logs técnicos e eventos de uso para segurança, operação, suporte e
              melhoria do serviço.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Finalidade e compartilhamento</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              Os dados são usados para autenticação, operação da conta, cobrança, atendimento e
              manutenção do serviço.
            </p>
            <p>
              Podemos utilizar fornecedores de infraestrutura, armazenamento, autenticação e pagamento,
              sempre dentro do necessário para prestar o serviço contratado.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Segurança e direitos</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              Adotamos medidas técnicas e organizacionais razoáveis para proteger os dados. Ainda assim,
              nenhum sistema é totalmente imune a falhas ou incidentes.
            </p>
            <p>
              O titular pode solicitar informações, correção ou exclusão de dados pessoais, observadas
              as obrigações legais e contratuais aplicáveis.
            </p>
          </CardContent>
        </Card>

        <Link to="/cadastro" className="text-sm font-medium text-primary hover:underline">
          Voltar para o cadastro
        </Link>
      </div>
    </div>
  )
}
